/*
 * Jira Ticket:
 * Created Date: Wed, 11th Mar 2020, 10:49:44 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import create from './create';
import edit from './edit';
import list from './list';
import icon from '@material-ui/icons/Business';

export default {
  create,
  edit,
  list,
  icon,
};
